<template>
  <div class="chat_talk" :class="{is_alone:isAlone}">
    <div class="talk_top" >
      <template v-if="agoraRoom">
        <div class="top_img">
          <img
            v-if="agoraRoom.exhibitor.company.logo"
            :src="agoraRoom.exhibitor.company.logo"
            
          />
          <img v-else src="@/assets/img/empty.png" >
        </div>
        <div class="top_info">
          <p>{{agoraRoom.exhibitor.company.name}}</p>
          <p class="tit">在线客服</p>
        </div>
      </template>
      <i @click="talkClose" class="close iconfont icon-guanbi"></i>
    </div>
    <div class="talk_msg chat" ref="chat" @touchmove.prevent>
      <div class="f-tac loading" v-if="loading">加载中...</div>
      <div class="chat_wrap" id="chat_wrap">
        <div class="chat_item" v-for="item in barrageList" :key="item.id">
          <!-- 对方 -->
          <template v-if="item.messageType=='text'">
            <div class="txt_left" v-if="!item.isUser">
              <div class="txt" v-html="item.message.content"></div>
            </div>
            <div class="txt_right" v-else>
              <div class="txt" v-html="item.message.content" ></div>
            </div>
          </template>
          <div class="txt_left" v-if="item.messageType == 'url'">
            <div class="txt room_info" @click.stop="joinVideoRoom(item)">
              <img :src="item.message.logo"  />
              <div class="comp_info">
                <p class="info_title">视频洽谈间</p>
                <p class="info_txt">
                  {{item.message.summary}}
                </p>
              </div>
            </div>
          </div>
          <div class="time" v-if="item.messageType == 'time'">
            {{ item.timeText }}
          </div>
          <div class="video_apply"  v-if="item.messageType=='request'">
            <p>您已向对方发起了视频洽谈申请，请稍等...</p>
          </div>
          <div class="video_apply" v-if="item.messageType == 'roomClose'">
            <p>非常抱歉，该视频洽谈间已关闭</p>
          </div>
        </div>
      </div>
    </div>
    <div class="talk_bottom">
      <div
        class="newBarrage"
        v-if="newBarrageList.length > 0"
        @click="getNewBarrage"
      >
        <i class="iconfont icon-qipao"><span>{{ newBarrageList.length }}</span></i>
      </div>
      <div class="bottom_btn">
        <i class="iconfont icon-shipin"  @click="getRoleHandle('L1ExShow-L2IM-L3Vidoe') && videoApplyClick()" v-if="isVideoConn" title="发起视频请求"></i>
        <i class="iconfont icon-jinzhishipin1"  v-else title="无法发起视频请求"></i>
      </div>
      <div class="input_con">
        <Input
          autofocus
          ref="inputText"
          class="input_text"
          :disabled="!exhibitorId"
          @touchmove.prevent
          @on-enter="send()"
          v-model="con"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 3 }"
          placeholder="请输入您要咨询的内容"
        />
      </div>
      <div class="send_wrap">
        <div class="send ok" v-if="con" @click="send">发送</div>
        <div class="send" v-else>发送</div>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Bscroll from "better-scroll";
import moment from "moment";
import AgoraRTM from 'agora-rtm-sdk'
import dateString from '../../assets/js/dateString'
import webUrl from "@/utils/url";
// Bscroll.use(MouseWheel)
export default {
  name: "chat-talk-user",
  props:{
    exhibitorId:{
      type:String,
      default:''
    },
    isAlone:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      con: "",
      loading:false,
      scroll: null,
      isBottom: true,
      isTouch: false,
      client:null,
      barrageList: [], //接受留言列表
      newBarrageList: [],
      pageIndex:1,
      pageSize:20,
      finished:false,
      spinShow:false,
      agoraRoom:null,
      showVideoBtn: true,
      timer: null,
      isVideoConn: false,
      isInform:false,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      exhibitionId: "getExhibitionId",
      userInfo: "getUser",
      getShare: "getShare",
    }),
    isRegOk() {
      return (
        this.userInfo &&this.userInfo.inMember&&
        this.userInfo.inMember.userRole &&
        this.userInfo.inMember.userRole != "VISITOR" &&
        this.userInfo.inMember.userRole != "Visitor"
      );
    },
    userId(){
      return this.userInfo.userId
    },
    msgQuery(){
      return `
        query($query:QueryInput!){
          agoraMessageQuery{
            query(query:$query){
              hasNextPage
              indexFrom
              totalCount
              pageIndex
              items{
                createAt
                exhibitorId
                id
                message
                messageType
                publisherId
                state
                stateAt
                userId
              }
            }
          }
        }`
    }
  },
  watch: {
    async exhibitorId(val, oldVal) {
      if(oldVal&&this.client){
        await this.invokingLogout();
      }
      this.con='';
      this.loading=false;
      this.isBottom=true;
      this.isTouch=false;
      this.barrageList=[];
      this.newBarrageList=[];
      this.pageIndex=1;
      this.pageSize=20;
      this.finished=false;
      this.spinShow=false;
      this.agoraRoom=null;
      this.showVideoBtn=true;
      this.timer=null;
      this.isVideoConn=false;
      this.isInform=false;
      this.client=null;
      this.$refs.inputText.focus()
      // Object.assign(this.$data, this.$options.data())
      this.init();
    },
  },
  created() {
    if(!this.exhibitorId){
      return 
    }
    // this.$store.commit('setToken','eyJhbGciOiJSUzI1NiIsImtpZCI6IkU2RkNGQjVGMjBEODAyOERCQTFGOEMzRTJDNUI2RDQ5IiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2MTQwNjU4MDUsImV4cCI6MTYxNTI3NTQwNSwiaXNzIjoiaHR0cHM6Ly9hdXRoLnpoYW5zaGFuZ3hpdS5jb20iLCJhdWQiOlsiYm1tLWFwaSIsInNob3dvbmxpbmUtYXBpIl0sImNsaWVudF9pZCI6InN5bmFpci1zaG93b25saW5lLWpzIiwic3ViIjoiMzZmYzNkOGUtZWNlNi00NGU3LTkyZGMtZjM3MTBlZDA4MTIyIiwiYXV0aF90aW1lIjoxNjE0MDY1ODA1LCJpZHAiOiJsb2NhbCIsImlhdCI6MTYxNDA2NTgwNSwic2NvcGUiOlsiYm1tLWFwaSIsIm9wZW5pZCIsInBob25lIiwicHJvZmlsZSIsInNob3dvbmxpbmUtYXBpIl0sImFtciI6WyJwaG9uZV9udW1iZXIiXX0.IBfyIaCrIgIIYEt8d5AEd11j0lvhCB43_xqU9F7XYoLunpQyE_a129Fv5indJLO09KfeyTXEMQKW2uoy3DWk8dq6rFxIpXTYkisL8gbOpX906ZHisfEAa0MAtomMZUMJW1gUqXgriCd5XeSOX1RoUzngVZxbgjivbbYlKcScp0oBtavuzlocNXWnYDbFdu731wLg9mM5SCkuyhSd-Sp4nwGluC2RTflb_QP2L-UTKj2gaRk6zR5BXlwmpmvPZ8U3YYwB7tfV2TE6M7nZIhNdOfTijdtk_Yk0ksgeze_vwN4-hdTnVoURSLBXoPcwBDWJHeuioG04JD83MUY584Qws')
    this.init()
  },
  async beforeDestroy(){
    console.log('退出了，',this.client)
    if(this.client){
     await this.invokingLogout()
    }
  },
  mounted() {
    this.initSwiper();
    this.$nextTick(()=>{
      this.$refs.inputText.focus()
    })
  },
  methods: {
    ...mapActions({
      unverifiedDialog: "unverifiedDialog",
      graphqlPostByZXS:'graphqlPostByZXS',
      agoraNotify:'talk/agoraNotify',
      addAgoraMessage:'talk/addAgoraMessage',
      getMessageToken:'talk/getMessageToken',
      upDateStateAgoraMessage:'talk/upDateStateAgoraMessage',
      readExhibitorMsg:'talk/readExhibitorMsg'
    }),
    invokingLogout(){
       return new Promise((resolve, reject)=>{
         this.client.logout().then(()=>{
           resolve(true)
          //  console.log('退出成功')
         }).catch(err=>{
           resolve(false)
         })
       })
    },
    init(){
      this.spinShow=true
      this.getAgoraRoom();
    },
    initSwiper() {
      this.scroll = new Bscroll(this.$refs.chat, {
        scrollY: true,
        click: true,
        probeType: 3,
        mouseWheel: true,
        pullDownRefresh:{
          threshold:20,
          stop: 20
        },
        bounce: {
          top: true,
          bottom: true,
        },
        // scrollbar: {
        //   fade: false,
        // },
      });
      let that = this;
      //用户轻抚
      this.scroll.on("flick", () => {
        let barAllH = $(".chat_wrap").height();
        let wrapH = $(".chat").height();
        if (barAllH > wrapH) {
          that.isTouch = true;
        }
      });
      // this.scroll.on("pullingUp",()=>{
      //   console.log('鼠标滚轮下拉触发',that.finished)
      //   if(that.finished){
      //     that.scroll.finishPullDown()
      //   }else{
      //     that.pageIndex+=1;
      //     that.loading=true;
      //     that.getMssage();
      //   }
      // })
      
      this.scroll.on("pullingDown",()=>{
        console.log('下拉触发',that.finished)
        if(that.finished){
          that.scroll.finishPullDown()
        }else{
          that.pageIndex+=1;
          that.loading=true;
          that.getMssage();
        }
      })
      //滚动中
      this.scroll.on("scroll", (obj) => {
        // if($('.barrage .bscroll-vertical-scrollbar .bscroll-indicator')){
        //    $('.barrage .bscroll-vertical-scrollbar .bscroll-indicator').addClass('scrollstyle');//
        // }
        let barAllH = $(".chat_wrap").height();
        // console.log( $(".chat_wrap"),'sss')
        let chatH = $(".chat").height();
        // console.log(barAllH,chatH)
        // console.log(barAllH - chatH,Math.abs(obj.y),'滚动中haodu')  // + 25
        if (barAllH - chatH <= Math.abs(obj.y) + 30) {
          that.isBottom = true;
          that.isTouch = false;
          if (that.newBarrageList.length) {
            that.getNewBarrage();
            // that.dataPush(model);
            // }
          }
        } else if (barAllH - chatH > 0) {
          that.isBottom = false;
        }
      });
    },
    //获取聊天室
    async getAgoraRoom(){
      
      let query=`
        query{
          agoraQuery{
            by(exhibitorId:"${this.exhibitorId}",userId:"${this.userId}"){
              id
              member{
                avatarUrl
                userId
                name
                nickName
              }
              exhibitor{
                company{
                  name
                  logo
                }
              }
            }
          }
        }
      `
      let opt={
        query:query,
        variables:{},
      }
      let data=await this.graphqlPostByZXS(opt);
      let res=JSON.parse(JSON.stringify(data.data.agoraQuery.by));
      if(!res.id){
        this.$Message.error('洽谈间信息有误，请重新进入')
        return 
      }
      this.agoraRoom=res;
      // console.log(res,'聊天室');
      // let query1=`
      //   query{
      //     agoraQuery{
      //       isLog(agoraId:"${this.agoraRoom.id}")
      //     }
      //   }
      // `
      // let opt1={
      //   query:query1,
      //   variables:{},
      // }
      // let data1=await this.graphqlPostByZXS(opt1);
      // let res1=JSON.parse(JSON.stringify(data1.data.agoraQuery.isLog));
      // this.logState=res1;
      // console.log(this.logState,'lotW5Q5w')
      this.getMssage(true);
    },
    //获取消息记录
    async getMssage(isCreate=false){
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualA: {
          n: "exhibitorId",
          v: this.exhibitorId,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt={
        query:this.msgQuery,
        variables: {
          query: {
            page: this.pageIndex,
            size: this.pageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          }
        },
      }
      let data=await this.graphqlPostByZXS(opt);
      let res=JSON.parse(JSON.stringify(data.data.agoraMessageQuery.query));
      // console.log(data.data.agoraMessageQuery.query,'resss');
      // let unRead=[];
      res.items.reverse();
      res.items.forEach(el => {
        el.message=JSON.parse(el.message)
        el.isUser=el.publisherId==el.userId;
        el.timeStr=dateString.getDataString(moment(el.createAt).format('x'),true)
        // if(!el.isUser){
        //   if(el.state=='unread'){
        //     unRead.push(el.id);
        //   }
        // }
        // let time=moment().from(el.createAt);
        // // let nowTime=moment(new Date()).diff(el.createAt,'minute');
        // let timeMoment=moment(el.createAt).calendar(moment(), {
        //     sameDay: 'HH:mm',
        //     lastDay: '[昨天] HH:mm',
        //     lastWeek: '[上周]dd',
        //     sameElse: 'YYYY/MM/DD',
        //     // sameElse:(now)=>{
        //     //   console.log(now,'其他时间')
        //     // }
        // });
        // el.timeStr=timeMoment;
      });
      // if(unRead.length){
        this.setRead();
      // }
      let arr=this.addDateList(res.items);
      this.barrageList=[...arr,...this.barrageList];
      console.log(this.barrageList,'ssss')
      if(isCreate){
        this.spinShow=false;
        this.initClinet();
        this.$nextTick(()=>{
          this.getNewBarrage();
        })
      }else{
        this.loading=false;
        this.scroll.finishPullDown();
        this.$nextTick(()=>{
          this.scroll.refresh();
        })
      }
      if (!res.hasNextPage) {
        this.finished = true;
      }
      
    },
    //进行时间添加
    addDateList(barrageList){
      let arr=[];
      // console.log(barrageList,'barrList')
      for (let i = 0; i < barrageList.length; i++) {
        let e=barrageList[i];
        let e1=barrageList[i+1];
        
        // console.log(e,e1,i,'e1e1e1')
        if(e.messageType=='time'){
          arr.push(e);
          continue
        }
        if(i == 0){
          let mode={
            timeText:e.timeStr,
            messageType:'time',
            id:this.getUUId()
          }
          arr.push(mode);
        }
        if(e1){
          let min=Math.abs(moment(e.createAt).diff(e1.createAt,'minute'));
          // console.log(min,e.createAt,e1.createAt,'miniminin')
          if(min>=10){
            let mode={
              timeText:e1.timeStr,
              messageType:'time',
              id:this.getUUId()
            }
            arr.push(e);
            if(i != 1){
              arr.push(mode);
            }
            continue
          }
        }
        // else{
        //   e1=barrageList[i-1];
        //   console.log(e,e1,i,'最后一个');
        //   let min=Math.abs(moment(e.createAt).diff(e1.createAt,'minute'));
        //   if(min>=10){
        //     let mode={
        //       timeText:e.timeStr,
        //       messageType:'time'
        //     }
        //     // arr.push(mode);
        //     arr.push(e);
        //     continue
        //   }
        // }
        arr.push(e);
        // console.log(barrageList[i].createAt,'createAt');
      }
      // this.barrageList=JSON.parse(JSON.stringify(arr));
      // console.log(arr,'arrrrr')
      return arr
    },
    //初始化链接
    async initClinet(){
      //要token db992c4127c6454f9229216503d3e839         不要token    d805985473ad41d99c13d7adb6aa5648
      this.client=AgoraRTM.createInstance('db992c4127c6454f9229216503d3e839');
      let opt={
        channelName:this.userId,   //频道名称
        userId:'',
        privileges:[1000]
      }
      let token=await this.getMessageToken(opt) //获取token
      console.log(token,'token','gooo')
      this.monitor();
      this.client.login({ token:token, uid:this.userId}).then(()=>{
        console.log('登录成功')
        this.client.subscribePeersOnlineStatus([this.agoraRoom.id]).then(()=>{
          console.log('订阅成功')
        }).catch(err=>{
          console.log(err,'订阅失败')
        })
      }).catch(err=>{
        this.$Message.error('登录失败')
        console.log(err,'登录失败')
      })
    },
    monitor(){
      this.client.on('ConnectionStateChanged', (newState, reason) => {
        console.log('状态：'+newState+'; 原因：'+reason);
      });
      this.client.on('MessageFromPeer', ({ text }, peerId) => {
        if(text){
          text=JSON.parse(text);
          // consoe.log('text对方客服');
          if(text.exhibitorId==this.exhibitorId){
            text.message=JSON.parse(text.message);
            text.isUser=false;
            if(text.state=='unread'){
              this.setRead();
            }
            this.dataPush(text)
          }
        }
        // text 为消息文本，peerId 是消息发送方 User ID
        console.log(text,'客服得消息接收')
        console.log(peerId,'发送方id-客服')
        /* 收到点对点消息的处理逻辑 */
      });
      this.client.on('PeersOnlineStatusChanged',(status)=>{
        if(status[this.agoraRoom.id]=='ONLINE'){
          this.isVideoConn=true;
        }else{
          this.isVideoConn=false;
        }
      })
    },
    //发送
    async send() {
      let str=JSON.parse(JSON.stringify(this.con)) ;
      if (!this.con) {
        return;
      }else if(!str.replace(/ /g,"")){
        this.$Message.warning('不能发送空白消息');
        return
      }
      let req={
        publisherId:this.userId,
        exhibitorId:this.exhibitorId,
        userId:this.userId,
        messageType:'text',
        message:JSON.stringify({content:this.con}),
      }
      let res=await this.addAgoraMessage(req);
      let opt=req;
      if(res&&res.result){
        opt=JSON.parse(JSON.stringify(res.data)) 
        this.client.sendMessageToPeer(
          { text: JSON.stringify(opt) }, // 符合 RtmMessage 接口的参数对象
          this.agoraRoom.id, // 远端用户 ID
        ).then(sendResult=> {
          //发送成功->往接口里面发数据
          opt.message=JSON.parse(opt.message);
          opt.isUser=true;
          this.dataPush(opt)
          if (sendResult.hasPeerReceived) {
            /* 远端用户收到消息的处理逻辑 说明在线 */
          } else {
            /* 服务器已接收、但远端用户不可达的处理逻辑 离线 */
          }
        }).catch(error => {
          this.$Message.error('发送失败');
          console.log(error,'client 发送失败')
          /* 发送失败的处理逻辑 */
        });       
        console.log(this.isInform,this.logState,'sssssss')
        // if(!this.isInform&&this.logState=='not'){
        //   let op={
        //     exhibitorId:this.exhibitorId,
        //     userId:this.userId,
        //     langVersion:'zh-cn'
        //   }
        //   this.agoraNotify(op);
        //   // let res=await this.agoraNotify(op);
        //   // console.log(res,'ressss')
        //   if(res&&res.result){
        //     this.isInform=true;
        //   }
        // }
        this.con='';
        //发送成功
      }else{
        this.$Message.error(res.message||'发送失败');
      };
   
      // let mode = {
      //   id: this.getUUId(),
      //   txt: this.con.replace(/ /g,"&nbsp;"),
      //   logo:
      //     "https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3516796069,1638897945&fm=15&gp=0.jpg",
      //   type: Math.random() >= 0.5 ? "from" : "me",
      // };
      // this.isBottom = true;
      // this.isTouch = false;
      // this.dataPush(mode);
      
    },
    
    setRead(){
      let opt={
        exhibitorId:this.exhibitorId,
        userId:this.userId
      } 
      this.readExhibitorMsg(opt);
    },
    //加入视频洽谈间
    joinVideoRoom(item){
      //判断发起人-发起客服是否还在聊天室-->聊天室是否关闭 关闭push提示 没关闭进入
      // return 
      if(item.state!='expire'){
        let opt={
          msgId:item.id,
          agoraId:this.agoraRoom.id,
          type:'user',
        }
        // this.LinkVideoTalk(opt);
        let url=`https://${webUrl['mobile']}/video-talk?msgId=${opt.msgId}&agoraId=${opt.agoraId}&type=${opt.type}`;
        window.open(url)
      }else{
        let opt={
          publisherId:this.userId,
          exhibitorId:this.exhibitorId,
          userId:this.userId,
          messageType:'roomClose',
          message:'',
          createAt:moment().format('YYYY/MM/DD HH:mm:ss')
        }
        //提示不用存入数据库
        this.dataPush(opt);
      }
    },
    downTime(){
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showVideoBtn = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showVideoBtn = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //视频连线点击
    async videoApplyClick(){
      console.log('哈哈');
      if(!this.showVideoBtn){
        this.$Message.warning('一分钟内只能发送一次视频洽谈申请');
        return
      }
      let msgRequst={
        type:'videoConn',             //请求类型
        text:'向您发起了视频洽谈申请'   //文字（动态不用传，如用户名等）
      }
      let req={
        publisherId:this.userId,
        exhibitorId:this.exhibitorId,
        userId:this.userId,
        messageType:'request',
        message:JSON.stringify(msgRequst),
      }
      let res=await this.addAgoraMessage(req);
      let opt=req;
      if(res&&res.result){
        opt=JSON.parse(JSON.stringify(res.data))  
        this.client.sendMessageToPeer(
          { text: JSON.stringify(opt) }, // 符合 RtmMessage 接口的参数对象
          this.agoraRoom.id, // 远端用户 ID
          ).then(sendResult=> {
            //发送成功->往接口里面发数据
            // console.log(sendResult,'sendR');
            opt.message=JSON.parse(opt.message);
            opt.isUser=false;
            this.dataPush(opt)
            
            if (sendResult.hasPeerReceived) {
              /* 远端用户收到消息的处理逻辑 说明在线 */
            } else {
              /* 服务器已接收、但远端用户不可达的处理逻辑 离线 */
            }
          }).catch(error => {
            this.$Message.warning('链接已断开，发送失败');
            console.log(error,'发送失败')
            /* 发送失败的处理逻辑 */
          });
        this.downTime();      
        //发送成功
      }else{
        this.$Message.warning('发送失败');
      };
      
    },

    
    getUUId() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    //设置滚动条滚动至底
    setScrollTop() {
      let Lis = $(".chat_item"); // 查找所有bar_block元素
      this.scroll.refresh();
      if(Lis&&Lis.length){
        this.scroll.scrollToElement(Lis[Lis.length - 1], 300); // 滑动到指定元素,设置动画300ms
      }
    },
    //数据存入
    dataPush(data) {
      let min=0;
      if(this.barrageList.length){
        if(this.barrageList[this.barrageList.length-1].messageType=='roomClose'||data.messageType=='roomClose'){
          min=0
        }else{
          min=Math.abs(moment(data.createAt).diff(this.barrageList[this.barrageList.length-1].createAt,'minute'));
        }
      }else{
        min=10;
      }
      if(min>=10){
        data.timeStr=dateString.getDataString(moment(data.createAt).format('x'),true)
        let mode={
          timeText:data.timeStr,
          messageType:'time',
          id:this.getUUId()
        }
        this.barrageList.push(mode)
      }
      this.barrageList.push(data);
      this.$nextTick(()=>{
        this.scroll.finishPullDown();
      })
      if (this.isBottom && !this.isTouch) {
        //
        // if(this.barrageList.length>20){    dom多了处理
        //    this.stortBarrageList.push(this.barrageList.shift());
        // }
        this.$nextTick(() => {
          this.setScrollTop();
        });
      } else {
        // this.newBarrageList.push(data);
        this.$set(this.newBarrageList, this.newBarrageList.length, data);
      }
      //
    },
    //读取新消息
    getNewBarrage() {
      this.newBarrageList = [];
      this.isBottom = true;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    talkClose(){
      if(this.isAlone){
        this.$Bus.$emit('talkAloneClose')
      }else{
        this.$Bus.$emit('talkClose')
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/my-theme/mixin.scss";
.chat_talk {
  width: 400px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0px 0px 20px 0px 
		rgba(0, 0, 0, 0.1);
    z-index: 2;
  &.is_alone{
    height:500px;
    position: fixed;
    right:190px;
    bottom: 145px;
    border-radius: 5px;
    z-index:998;
  }
  &::v-deep .ivu-spin{
    @include font_color(#1890ff);
    .ivu-spin-main{
      .ivu-spin-text{
        i{
          @include font_color(#1890ff);
        }
      }
    }
  }
  .talk_top {
    flex-shrink: 0;
    width: 100%;
    height: 62px;
    @include background_color(#1890ff);
    display: flex;
    align-items: center;
    padding: 10px;
    .top_img {
      flex-shrink: 0;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .top_info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 14px;
        color: #fff;
        &.tit {
          font-size: 12px;
        }
      }
    }
    .close {
      flex-shrink: 0;
      font-size: 14px;
      color: #fff;
      margin-left: auto;
      cursor: pointer;
      margin-right: 14px;
    }
  }
  .talk_msg {
    flex-shrink: 0;
    height: 315px;
    width: 100%;
    background: #f5f8fa;
    position: relative;
    // overflow-y: auto;
    overflow: hidden;
    // -ms-overflow-style: none;
    // overflow: -moz-scrollbars-none;
    
    .chat_wrap{
      // height: 100%;
      padding: 0 14px;
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 10px;
      }
      &::-webkit-scrollbar {
        width: 6px;
        // opacity: 0;
      }
      &::-webkit-scrollbar-track {
        background: rgba(#000, 0);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba($color: #000000, $alpha: 0.1);
        border-radius: 3px;
      }
      .chat_item{
        display: flex;
        width: 100%;
      }
      .txt{
        min-height:32px;
        display: flex;
        align-items: center;
        font-size: 14px;
        max-width: 246px;
        background-color: #ffffff;
        padding:5px 10px;
        &.room_info {
          width: 246px;
          padding: 10px 15px 10px 10px;
          align-items: initial;
          cursor: pointer;
          user-select: none;
          img {
            width: 64px;
            height: 64px;
            border-radius:10px;
            margin-right:10px;
            flex-shrink: 0;
            display: block;
          }
          .comp_info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: calc(100% - 74px);
            .info_title {
              color: #333;
              font-size: 16px;
            }
            .info_txt {
              margin-top: 5px;
              color: #666;
              font-size: 12px;
            }
          }
        }
      }
      .txt_left{
        .txt{
          border-radius: 0px 5px 5px 5px;
        }
      }
      .txt_right{
        .txt{
          border-radius: 5px 0px 5px 5px;
        }
      }
      .txt_left,.txt_right{
        margin-top: 20px;
        &.txt_right{
          margin-left: auto;
        }
      }
      //时间
      .time {
        display: flex;
        margin: 20px auto 0;
        align-items: center;
        height: 24px;
        padding: 0 10px;
        background: #fff;
        border-radius: 5px;
        @include font_color(#1890ff);
        box-shadow: 0px 5px 10px 0px 	rgba(91, 139, 237, 0.1);
        font-size:12px;
      }
      .video_apply{
        display: flex;
        margin: 20px auto 0;
        align-items: center;
        height: 34px;
        padding: 0 30px;
        background: #fff;
        box-shadow: 0px 5px 10px 0px rgba(91, 139, 237, 0.1);
        border-radius: 5px;
        p {
          color: #333;
          font-size: 12px;
          span {
            margin-left: 5px;
            font-size: 12px;
            color: #1890ff;
          }
        }
      }
    }
  }
  .talk_bottom {
    height: 123px;
    width: 400px;
    background: #fff;
    border-top: 1px solid #e6e6e6;
    padding: 0 12px;
    position: relative;
    .newBarrage{
      position: absolute;
      right: 15px;
      top: -34px;
      // cursor: pointer;
      user-select: none;
      i{
       font-size: 22px;
      //  color: #1890ff;
       @include font_color(#1890ff);
       position: relative;
       span{
         color: #fff;
         position: absolute;
         top: 50%;
         left: 50%;
         font-size: 14px;
         transform: translate(-50%,-50%);
       }
     }
    }
    .bottom_btn {
      height: 25px;
      i {
        font-size: 18px;
        cursor: pointer;
      }
    }
    .input_con {
      width: 100%;
      .input_text {
        &::v-deep .ivu-input {
          padding: 0;
          border: none;
          border-radius: 0;
          box-shadow: none;
          &[disabled]{
            background:#fff;
            color:#999;
          }
          &::-webkit-scrollbar {
            width: 6px;
            // opacity: 0;
          }
          &::-webkit-scrollbar-track {
            background: rgba(#000, 0);
            border-radius: 2px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba($color: #000000, $alpha: 0.1);
            border-radius: 3px;
          }
        }
      }
    }
    .send_wrap {
      width: 100%;
      display: flex;
      margin-top: 3px;
      .send {
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 26px;
        background-color: #f5f5f5;
        border-radius: 5px;
        color: #666;
        font-size: 14px;
        user-select: none;
        cursor: pointer;
        &.ok {
          color: #fff;
          @include background_color(#1890ff);
        }
      }
    }
  }
  .f-tac {
    text-align: center;
  }
  .loading {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin-top: 20px;
    // opacity: ;
    // overflow: hidden;
    // transition: height .3s;
    // &.open{

    // }
    // position: absolute;
    // width: 100%;
    // top: 0;
    // left: 0;
    img {
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 5px;
      animation: 1s loader-01 linear infinite;
    }
  }
  @keyframes loader-01 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
